module.exports = __webpack_public_path__ + "img/Iran_Zamin.92066da3.svg";